// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/standard.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header.css */

.site-header {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center/cover;
  padding: 0;
  color: white;
  position: sticky;
  top: 0;
  z-index: 1000;
  transition: all 0.4s ease;
}

.site-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 0;
  transition: background 0.3s ease;
}

.site-header.scrolled {
  padding: 10px 0;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}

.site-header.scrolled::before {
  background: rgba(0, 10, 30, 0.95);
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.site-header > * {
  position: relative;
  z-index: 1;
}

.logo {
  font-size: 1.8em;
  font-weight: 800;
  letter-spacing: -0.5px;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-text {
  background: linear-gradient(90deg, #ffffff, #66ccff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.logo-highlight {
  font-weight: 900;
  color: #66ccff;
  -webkit-text-fill-color: #66ccff;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.search-container {
  display: flex;
  align-items: center;
  position: relative;
  transition: all 0.3s ease;
}

.search-input {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 30px;
  padding: 10px 20px;
  color: white;
  font-size: 0.9rem;
  width: 0;
  opacity: 0;
  transition: all 0.3s ease;
  outline: none;
}

.search-container.active .search-input {
  width: 250px;
  opacity: 1;
}

.search-toggle {
  background: none;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.search-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 30px;
}

.nav-links a {
  text-decoration: none;
  color: white;
  font-weight: 500;
  font-size: 1rem;
  position: relative;
  padding: 5px 0;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-links a:hover {
  color: #66ccff;
}

.nav-links a::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #66ccff;
  transition: width 0.3s ease;
}

.nav-links a:hover::after,
.nav-links a.active::after {
  width: 100%;
}

.nav-icon {
  font-size: 1.1rem;
}

.nav-button {
  background: linear-gradient(90deg, #0066cc, #0099ff);
  color: white;
  padding: 4px 4px !important;
  border-radius: 24px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.nav-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
  background: linear-gradient(90deg, #0099ff, #0066cc);
}

.nav-button::after {
  display: none;
}

/* User dropdown styles */
.user-dropdown {
  position: relative;
}

.dropdown-toggle {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  color: white;
  padding: 5px;
  border-radius: 30px;
  transition: all 0.3s ease;
}

.dropdown-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
}

.user-avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0066cc, #0099ff);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.user-name {
  font-weight: 500;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background: rgba(0, 20, 40, 0.95);
  border-radius: 8px;
  min-width: 200px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  padding: 10px 0;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.dropdown-menu::before {
  content: '';
  position: absolute;
  top: -6px;
  right: 20px;
  width: 12px;
  height: 12px;
  background: rgba(0, 20, 40, 0.95);
  transform: rotate(45deg);
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  color: white;
  text-decoration: none;
  transition: all 0.2s ease;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.95rem;
}

.dropdown-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #66ccff;
}

.dropdown-icon {
  font-size: 1rem;
  color: #66ccff;
}

.hamburger {
  display: none;
  cursor: pointer;
  font-size: 1.5rem;
  color: white;
  background: rgba(255, 255, 255, 0.1);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: none;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.hamburger:hover {
  background: rgba(255, 255, 255, 0.2);
}

.theme-toggle {
  background: none;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  margin-right: 10px;
}

.theme-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(15deg);
}

.dark-mode .theme-toggle {
  color: #ffcc00;
}

/* Dark mode styling for header elements */
.dark-mode .site-header::before {
  background: rgba(0, 0, 0, 0.8);
}

.dark-mode .search-input {
  background: rgba(0, 0, 0, 0.3);
  color: #f5f5f5;
}

.dark-mode .search-toggle,
.dark-mode .hamburger,
.dark-mode .dropdown-toggle {
  background: rgba(0, 0, 0, 0.3);
}

.dark-mode .dropdown-menu {
  background: rgba(15, 15, 15, 0.95);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
}

.dark-mode .dropdown-item {
  color: #f5f5f5;
}

.dark-mode .dropdown-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* Mobile styles */
@media (max-width: 992px) {
  .header-container {
    padding: 15px 20px;
  }
  
  .header-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .hamburger {
    display: flex;
  }
  
  .nav-links {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    background-color: rgba(0, 20, 40, 0.95);
    padding: 20px;
    gap: 20px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    align-items: flex-start;
  }
  
  .nav-links.open {
    display: flex;
    opacity: 1;
    z-index: 9999;
  }
  
  .nav-links a {
    width: 100%;
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .nav-links a:last-child {
    border-bottom: none;
  }
  
  .search-container.active .search-input {
    width: 150px;
  }
  
  .user-dropdown {
    width: 100%;
  }
  
  .dropdown-toggle {
    width: 100%;
    justify-content: flex-start;
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .dropdown-menu {
    position: relative;
    top: 10px;
    right: auto;
    width: 100%;
    box-shadow: none;
    background: transparent;
    padding: 0;
    margin-left: 20px;
  }
  
  .dropdown-menu::before {
    display: none;
  }
  
  .dropdown-item {
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .dropdown-item:last-child {
    border-bottom: none;
  }
  
  .theme-toggle {
    margin-right: 20px;
  }
  
  .dark-mode .nav-links {
    background: #121212;
    border-color: #333;
  }
}

@media (min-width: 993px) {
  .hamburger {
    display: none;
  }
  
  .nav-links {
    display: flex;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,0EAA8D;EAC9D,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,OAAO;IACP,uCAAuC;IACvC,aAAa;IACb,SAAS;IACT,0CAA0C;IAC1C,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,eAAe;IACf,iDAAiD;EACnD;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Header.css */\n\n.site-header {\n  background: url('/public/standard.gif') no-repeat center/cover;\n  padding: 0;\n  color: white;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  transition: all 0.4s ease;\n}\n\n.site-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 0;\n  transition: background 0.3s ease;\n}\n\n.site-header.scrolled {\n  padding: 10px 0;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);\n}\n\n.site-header.scrolled::before {\n  background: rgba(0, 10, 30, 0.95);\n}\n\n.header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 40px;\n  max-width: 1400px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.site-header > * {\n  position: relative;\n  z-index: 1;\n}\n\n.logo {\n  font-size: 1.8em;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  transition: transform 0.3s ease;\n}\n\n.logo:hover {\n  transform: scale(1.05);\n}\n\n.logo-text {\n  background: linear-gradient(90deg, #ffffff, #66ccff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.logo-highlight {\n  font-weight: 900;\n  color: #66ccff;\n  -webkit-text-fill-color: #66ccff;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.search-container {\n  display: flex;\n  align-items: center;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.search-input {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  border-radius: 30px;\n  padding: 10px 20px;\n  color: white;\n  font-size: 0.9rem;\n  width: 0;\n  opacity: 0;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.search-container.active .search-input {\n  width: 250px;\n  opacity: 1;\n}\n\n.search-toggle {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.2rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n}\n\n.search-toggle:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n}\n\n.nav-links a {\n  text-decoration: none;\n  color: white;\n  font-weight: 500;\n  font-size: 1rem;\n  position: relative;\n  padding: 5px 0;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.nav-links a:hover {\n  color: #66ccff;\n}\n\n.nav-links a::after {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 2px;\n  bottom: 0;\n  left: 0;\n  background-color: #66ccff;\n  transition: width 0.3s ease;\n}\n\n.nav-links a:hover::after,\n.nav-links a.active::after {\n  width: 100%;\n}\n\n.nav-icon {\n  font-size: 1.1rem;\n}\n\n.nav-button {\n  background: linear-gradient(90deg, #0066cc, #0099ff);\n  color: white;\n  padding: 4px 4px !important;\n  border-radius: 24px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.nav-button:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);\n  background: linear-gradient(90deg, #0099ff, #0066cc);\n}\n\n.nav-button::after {\n  display: none;\n}\n\n/* User dropdown styles */\n.user-dropdown {\n  position: relative;\n}\n\n.dropdown-toggle {\n  background: none;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  color: white;\n  padding: 5px;\n  border-radius: 30px;\n  transition: all 0.3s ease;\n}\n\n.dropdown-toggle:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.user-avatar {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #0066cc, #0099ff);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 16px;\n  color: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.user-name {\n  font-weight: 500;\n  max-width: 100px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: 0;\n  background: rgba(0, 20, 40, 0.95);\n  border-radius: 8px;\n  min-width: 200px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);\n  padding: 10px 0;\n  z-index: 1000;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.dropdown-menu::before {\n  content: '';\n  position: absolute;\n  top: -6px;\n  right: 20px;\n  width: 12px;\n  height: 12px;\n  background: rgba(0, 20, 40, 0.95);\n  transform: rotate(45deg);\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 20px;\n  color: white;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.95rem;\n}\n\n.dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #66ccff;\n}\n\n.dropdown-icon {\n  font-size: 1rem;\n  color: #66ccff;\n}\n\n.hamburger {\n  display: none;\n  cursor: pointer;\n  font-size: 1.5rem;\n  color: white;\n  background: rgba(255, 255, 255, 0.1);\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.hamburger:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.theme-toggle {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.2rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n  margin-right: 10px;\n}\n\n.theme-toggle:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: rotate(15deg);\n}\n\n.dark-mode .theme-toggle {\n  color: #ffcc00;\n}\n\n/* Dark mode styling for header elements */\n.dark-mode .site-header::before {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.dark-mode .search-input {\n  background: rgba(0, 0, 0, 0.3);\n  color: #f5f5f5;\n}\n\n.dark-mode .search-toggle,\n.dark-mode .hamburger,\n.dark-mode .dropdown-toggle {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.dark-mode .dropdown-menu {\n  background: rgba(15, 15, 15, 0.95);\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);\n}\n\n.dark-mode .dropdown-item {\n  color: #f5f5f5;\n}\n\n.dark-mode .dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* Mobile styles */\n@media (max-width: 992px) {\n  .header-container {\n    padding: 15px 20px;\n  }\n  \n  .header-right {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .hamburger {\n    display: flex;\n  }\n  \n  .nav-links {\n    display: none;\n    flex-direction: column;\n    position: absolute;\n    top: 100%;\n    right: 0;\n    left: 0;\n    background-color: rgba(0, 20, 40, 0.95);\n    padding: 20px;\n    gap: 20px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n    align-items: flex-start;\n  }\n  \n  .nav-links.open {\n    display: flex;\n    opacity: 1;\n    z-index: 9999;\n  }\n  \n  .nav-links a {\n    width: 100%;\n    padding: 10px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n  \n  .nav-links a:last-child {\n    border-bottom: none;\n  }\n  \n  .search-container.active .search-input {\n    width: 150px;\n  }\n  \n  .user-dropdown {\n    width: 100%;\n  }\n  \n  .dropdown-toggle {\n    width: 100%;\n    justify-content: flex-start;\n    padding: 10px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n  \n  .dropdown-menu {\n    position: relative;\n    top: 10px;\n    right: auto;\n    width: 100%;\n    box-shadow: none;\n    background: transparent;\n    padding: 0;\n    margin-left: 20px;\n  }\n  \n  .dropdown-menu::before {\n    display: none;\n  }\n  \n  .dropdown-item {\n    padding: 10px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n  \n  .dropdown-item:last-child {\n    border-bottom: none;\n  }\n  \n  .theme-toggle {\n    margin-right: 20px;\n  }\n  \n  .dark-mode .nav-links {\n    background: #121212;\n    border-color: #333;\n  }\n}\n\n@media (min-width: 993px) {\n  .hamburger {\n    display: none;\n  }\n  \n  .nav-links {\n    display: flex;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
